import script from "./UserSupervisorAddModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserSupervisorAddModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserSupervisorAddModal.vue?vue&type=style&index=0&id=e0d939ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d939ee"]])

export default __exports__